document.addEventListener('DOMContentLoaded', function () {
	const popup = document.getElementById('pophihide1');
	const closeBtn = document.getElementById('continue-reading');
	const popupOverlay = document.getElementsByClassName('newsletter-overlay-backgound');
	const form = document.getElementById('popup-newsletter-form');
	const successMessage = document.getElementById('newsletter-success');
	const alreadySubscribed = document.getElementById('newsletter-already-subscribed');
	const subscribeHeading = document.getElementById('subscribe_heading');
	const subscribeDescription = document.getElementById('subscribe_description');

	function getsubCookie(cname) {
		const name = cname + '='; //eslint-disable-line
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) { //eslint-disable-line
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}
	const servicebtn = document.getElementById('survieenowbutton');
	if (servicebtn) {
		servicebtn.onclick = function () {
			document.getElementById('pophihide').style.display = 'none';
			document.getElementById('pophihide1').style.display = 'none';
		};
	}

	const cookiesbCheck = getsubCookie('newsletter_subs_popup_set');
	if (cookiesbCheck === '') {
		if (popupOverlay[0]) popupOverlay[0].style.display = 'block';
		if (popup) popup.style.display = 'flex';
	}
	if (form) {
		form.querySelector('button[type="submit"]');
		// Submit form and display success message
		form.addEventListener('submit', function (e) {
			e.preventDefault();
			// Perform AJAX request or any other form submission logic here
			const emailInput = document.getElementById('newsletter-email-id');
			const email = emailInput.value;
			const emailInputTo = document.getElementById('newsletter-email-to');
			const emailTo = emailInputTo.value;
			const subjectInput = document.getElementById('newsletter-subject');
			const subject = subjectInput.value;
			const bodyInput = document.getElementById('newsletter-body');
			const body = bodyInput.value;
			const nonceInput = document.getElementById('newsletter-nonce-popup');
			const nonce = nonceInput.value;
			// Create a new XMLHttpRequest object
			const xhr = new XMLHttpRequest();
			// Set up the AJAX request
			xhr.open('POST', ajaxload_params.ajaxurl, true); //eslint-disable-line
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			// Handle the AJAX response
			xhr.onload = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					const response = JSON.parse(xhr.responseText);
					if (response.success) {
						document.cookie =
							'newsletter_subs_popup_set=1; expires=Thu, 18 Dec 3030 12:00:00 UTC; path=/';
						successMessage.style.display = 'flex';
						form.style.display = 'none';
						subscribeHeading.style.display = 'none';
						subscribeDescription.style.display = 'none';
						alreadySubscribed.style.display = 'none';
						form.reset();
					} else {
						alreadySubscribed.style.display = 'block';
					}
				}
			};
						xhr.send(`action=newsletter_signup&email=${email}&nonce=${nonce}&emailTo=${emailTo}&subject=${subject}&body=${body}`); //eslint-disable-line
		});
		// Reset form and hide success message when popup is closed
		closeBtn.addEventListener('click', function () {
			form.reset();
			successMessage.style.display = 'none';
		});
	}
});
